<script>
import { mapState, mapActions } from 'vuex';
import TwTitleBar from '../../../components/TwTitleBar';

export default {
  name: 'SkistarWrapper',
  components: {
    TwTitleBar,
  },
  methods: {
    ...mapActions({
      loadResorts: 'skistar/loadResorts',
      clearState: 'skistar/clearState',
    }),
  },
  computed: {
    ...mapState({
      resorts: state => state.skistar.resorts.items,
    }),
    breadcrumbs() {
      return [
        { text: this.$t('menu.ski.title'), to: '', disabled: true },
        { text: this.$t('menu.ski.pages.skistar.title'), to: '', disabled: true },
        { text: this.$t(`breadcrumbs.${this.$route.name}`), to: this.$route.path },
      ];
    },
  },
  mounted() {
    if (!this.resorts.length) {
      this.loadResorts();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.clearState();
    next();
  },

};
</script>

<template>
  <v-content>
    <tw-title-bar
      :title="$t('menu.ski.pages.skistar.title')"
      :breadcrumbs="breadcrumbs">
    </tw-title-bar>
    <v-container>
      <v-layout row>
        <v-flex xs12>
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>



// WEBPACK FOOTER //
// src/pages/ski/skistar/SkistarWrapper.vue